<div (window:resize)="onResize($event)" class="d-lg"></div>